import { ProductTypes } from '@/common/enums';
import PlaySvg from '@/common/components/PlaySvg.vue';
import CanvasSvg from '@/common/components/CanvasSvg.vue';

export function getSVGComponent(type: string) {
  switch (type.toLowerCase()) {
    case ProductTypes.PLAY:
      return PlaySvg;
    case ProductTypes.CANVAS:
      return CanvasSvg;
    default:
      return PlaySvg;
  }
}

export default getSVGComponent;
